import $ from 'jquery';
import cx from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';
import NavMenu from './nav-menu';
import DownIcon from 'grommet/components/icons/base/Down';
import Utils from 'medscape/utils';
import SideNavInlineMenu from './side-nav-inline-menu';
import SideNaveLayerMenu from './side-nav-layer-menu';
import TopNavLayerMenu from './top-nav-layer-menu';

export default class Navigation extends React.Component{
    constructor(props){
        super(props);
        this.settings = props.isMobile ? props.navigation.mobile : props.navigation.desktop;
    }

    render() {
        //console.log("Render Nav");
		
        if(this.settings.position=='top'){
            //console.log("Loading Top Nav Layered Menu");
            return(
                <TopNavLayerMenu {...this.props} />
            )
        }
        else if(this.settings.submenuType=='layer'){
            //console.log("Loading Side Nav Layered Menu");
            return (
                <SideNaveLayerMenu {...this.props } />         
            )
        }
        else{
            //console.log("Loading Side Nav Inline Menu");
            return (
                <SideNavInlineMenu {...this.props} />
            );
        }
    }
}

Navigation.propTypes={
    "navigation": React.PropTypes.object.isRequired,
    "route": React.PropTypes.object.isRequired,
    "isMobile": React.PropTypes.bool
}
Navigation.defaultProps={
	"isMobile": window.medscape.isMobile ? window.medscape.isMobile : false
}





// WEBPACK FOOTER //
// ./src/app/navigation/app.jsx